import "./Switch.scss";
import { useState } from "react";

const Switch = ({ typeChange, dataType }) => {
    const [value, setValue] = useState(dataType);
    const changeHandler = (e) => {
        setValue(e.target.value);
        typeChange(e.target.value);
    };
    return (
        <div className="switch">
            <input
                type="radio"
                name="switch"
                value="grid"
                checked={value == "grid" ? true : false}
                id="switch-grid"
                onChange={changeHandler}
            />
            <label htmlFor="switch-grid"> Grid </label>
            <input
                type="radio"
                name="switch"
                value="carousel"
                checked={value == "carousel" ? true : false}
                id="switch-carousel"
                onChange={changeHandler}
            />
            <label htmlFor="switch-carousel"> Carousel </label>
        </div>
    );
};

export default Switch;
